/**
 * downloadHelpers.js
 * --------------------------------------------------------------------------
 * Small shared utilities for "export" and "download" actions across the app.
 * These produce real, downloadable text-format files. They're intentionally
 * simple, for the investor demo, the value is showing that buttons DO
 * something tangible (file lands in Downloads folder), not generating
 * production-grade PDFs/CSVs from every screen.
 *
 * For the polished PDF flow used by the dashboard, see /pdf/DirectiveReportPDF.
 */

/** Trigger a browser download of the given text content. */
export function triggerTextDownload(filename, content) {
  try {
    const blob = new Blob([content], { type: 'text/plain;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    setTimeout(() => URL.revokeObjectURL(url), 1000);
    return true;
  } catch (err) {
    console.error('triggerTextDownload failed', err);
    return false;
  }
}

/** Trigger a CSV download. items = array of plain objects with same keys. */
export function triggerCsvDownload(filename, items) {
  if (!items || items.length === 0) {
    return triggerTextDownload(filename, 'No data\n');
  }
  const headers = Object.keys(items[0]);
  const escape = (v) => {
    if (v == null) return '';
    const s = String(v).replace(/"/g, '""');
    return /[",\n\r]/.test(s) ? `"${s}"` : s;
  };
  const lines = [
    headers.join(','),
    ...items.map((row) => headers.map((h) => escape(row[h])).join(',')),
  ];
  const blob = new Blob([lines.join('\n')], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 1000);
  return true;
}

/** ISO date stamp suitable for filenames (e.g. '2026-04-29'). */
export function dateStamp(d = new Date()) {
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
}
